export const REASONS_KEY = 'report-a-problem_reasons';
export const MESSAGE_KEY = 'report-a-problem_message';
export const CONFERENCE_ID_KEY = 'report-a-problem_conferenceId';
